export const accountPage = () =>
  import("./AccountPage").then((m) => ({ Component: m.AccountPage }));
